import React, { PropsWithChildren } from "react";
import FocusLock from "react-focus-lock";

import "./modal.css";

export const Modal = ({
	isOpen,
	children,
	onScrimClick,
}: PropsWithChildren<{
	isOpen: boolean;
	onScrimClick?: () => void;
}>) => {
	if (!isOpen) {
		return null;
	}

	return (
		<>
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions*/}
			<div
				className="modal__scrim"
				onClick={() => {
					onScrimClick?.();
				}}
			/>
			<FocusLock>{children}</FocusLock>
		</>
	);
};

Modal.displayName = "Modal";
